import React, { Component } from "react";
import PropTypes from "prop-types";
import { Star } from "components/icons/Star";
import { StarOutline } from "components/icons/StarOutline";

export class StarRating extends Component {
  constructor (props) {
    super(props);

    this.renderStars = this.renderStars.bind(this);
  }

  renderStars () {
    let returnable = [],
        flatRating = Math.floor(this.props.rating);

    for (let n = 0; n < flatRating; n++) {
      returnable.push(
        <Star key={n} fill={"#FF7DA4"}/>
      );
    }

    if (returnable.length < 5) {
      while (returnable.length < 5) {
        returnable.push(
          <StarOutline key={returnable.length} fill={"#FF7DA4"}/>
        );
      }
    }

    return returnable;
  }

  render () {
    return (
      <div className={this.props.className}>
        {this.renderStars()}
      </div>
    );
  }
}

StarRating.defaultProps = {
  rating: 0,
  className: "star-rating"
};

StarRating.propTypes = {
  className: PropTypes.string,
  rating: PropTypes.number
};
